module.exports = __webpack_public_path__ + "resource/img/image003Dark.db5759fc.png";